<!--<template>
  <div class="popup" id="popup">
    <div class="popup__content popup--animate">
      <div class="popup__header">
        <svg class="popup__icon">
          <use href="@/assets/sprite.svg#icon-user"></use>
        </svg>
        <h1 class="heading-tertiary">{{ $t('popup.syncPrestaNode.replayQueue.title') }}</h1>
      </div>
      <div class='popup__form'>
        <v-jsoneditor v-model="queue.data" :plus="false" @onError="replayQueueJsonError"/>
      </div>
      <div class="popup__footer">
        <button class="popup__link u-pointer" type="button" @click='close'>{{ $t('popup.syncPrestaNode.replayQueue.cancelAction') }}</button>
        <button class="popup__link u-pointer" type="button" @click='replay'>{{ $t('popup.syncPrestaNode.replayQueue.confirmAction') }}</button>
      </div>
    </div>
  </div>
</template>-->

<template>
    <el-dialog :title="$tc('popup.syncPrestaNode.replayQueue.title')" :visible.sync="visible">
      <v-jsoneditor v-model="jsonData" height="400px" :options="{mode:'tree'}" @onError="replayQueueJsonError"/>
      <div slot="footer" class="dialog-footer">
        <button class="popup__link u-pointer" type="button" @click='close'>{{ $t('popup.syncPrestaNode.replayQueue.cancelAction') }}</button>
        <button class="popup__link u-pointer" type="button" @click='replay'>{{ $t('popup.syncPrestaNode.replayQueue.confirmAction') }}</button>
      </div>
    </el-dialog>
</template>

<script>
// import { HTTP_CLIENT } from '@/axios-wrapper'
import { toastMixin } from '@/components/Mixins/Toast'
import VJsoneditor from 'v-jsoneditor'

export default {
  data: function () {
    return {
      jsonData: JSON.parse(this.queue.data)
    }
  },
  props: {
    queue: Object
  },
  components: {
    VJsoneditor
  },
  mixins: [toastMixin],
  computed: {
    visible: {
      get () {
        return true
      },
      set (event) {
        if (!event) this.close()
      }
    }
  },
  methods: {
    replay () {
      alert('TODO')
      this.$emit('popup:forceRefresh', true)
    },
    replayQueueJsonError () {
      alert('TODO')
    },
    close () {
      this.$store.commit('syncPrestaNode/SHOW_REPLAY_QUEUE_POPUP', false)
    }
  },
  mounted () {
    console.log(this.queue)
  }
}
</script>
